import apiClient from './client';
import type {
  LoginCredentials,
  GoogleAuthCredentials,
  AuthResponse,
  UserPermissions
} from '@/types/user';

export const authApi = {
  login: async (credentials: LoginCredentials): Promise<AuthResponse> => {
    const response = await apiClient.post<AuthResponse>('/api/auth/login', credentials);
    return response.data;
  },

  googleLogin: async (credentials: GoogleAuthCredentials): Promise<AuthResponse> => {
    const response = await apiClient.post<AuthResponse>('/api/auth/google', credentials);
    return response.data;
  },

  getCurrentUser: async (): Promise<UserPermissions> => {
    const response = await apiClient.get<UserPermissions>('/api/auth/me');
    return response.data;
  },

  logout: async (): Promise<void> => {
    await apiClient.post('/api/auth/logout');
  },
};
